import { render, staticRenderFns } from "./AppVendorModal.vue?vue&type=template&id=be53b6e6&scoped=true&"
import script from "./AppVendorModal.vue?vue&type=script&lang=js&"
export * from "./AppVendorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be53b6e6",
  null
  
)

export default component.exports